import "./NordicBite.module.css";
import Header from "@/reusable_sections/Header";
import ATaleOfFlavors from "./sections/ATaleOfFlavors";
import TheFreshStandard from "./sections/TheFreshStandard";
import SignatureCreations from "./sections/SignatureCreations";
import MorningStories from "./sections/MorningStories";
import TheCreedExperience from "./sections/TheCreedExperience";
import TableReservations from "./sections/TableReservations";
import Footer from "@/reusable_sections/Footer";
export default function NordicBitePage() {
  return <div>
      <Header />
      <ATaleOfFlavors />
      <TheFreshStandard />
      <SignatureCreations />
      <MorningStories />
      <TheCreedExperience />
      <TableReservations />
      <Footer />
    </div>;
}